import { FC, Suspense, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

import { useDispatch } from '@bonusly/events';
import { useCurrentCompany, useCurrentUser } from '@bonusly/who-am-i';

import { useSurvicate } from './hooks';

export const AppContent: FC = () => {
	const { i18n } = useTranslation('monarch');
	const company = useCurrentCompany();
	const user = useCurrentUser();
	const location = useLocation();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	useSurvicate();

	useEffect(() => {
		const locale = user?.locale || company?.locale;

		if (locale) {
			i18n.changeLanguage(locale);
		}
	}, [company?.locale, i18n, user.locale]);

	useEffect(() => {
		if (location.pathname === '/invite') {
			const to = setTimeout(() => {
				dispatch('open-user-invite-modal');
				navigate('');
			}, 1500);
			return () => clearTimeout(to);
		}
	}, [dispatch, location, navigate]);

	return (
		<Suspense>
			<Outlet />
		</Suspense>
	);
};
